import { Stack } from '@mui/material';
import { useDataProvider, useLocalization } from '@ui-framework/index';
import { PageSection } from '@product-framework/index';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import DispatchNotifications from '../../components/DispatchNotifications';
import InsightContact from '../../components/InsightContact';
import getConfig from '../../configs/sp-config';
import {
  useServiceProvider,
  withServiceProvider,
} from '../../../../providers/ServiceProviderProvider';
import ServiceProviderLayout from '../../components/ServiceProviderLayout';
import getSPLevelStackableButtons from '../../utils/getSPLevelStackableButtons';

function Setup() {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const { serviceProviderId, refreshData } = useServiceProvider();

  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl } = useDataProvider(provider);

  const config = getConfig({
    apiBaseUrl: getApiUrl(),
    serviceProviderId,
  });

  const onChange = () => {
    refreshData({
      refreshProfileWarnings: true,
    });
  };

  return (
    <ServiceProviderLayout
      selectedStepperId="SETUP"
      stackablePageButtons={getSPLevelStackableButtons({
        navigate,
      })}>
      <PageSection
        label={formatMessage({
          id: 'SETUP',
          defaultMessage: 'Setup',
        })}>
        <Stack spacing={4} sx={{ width: '100%' }}>
          <DispatchNotifications config={config} onChange={onChange} />
          <InsightContact config={config} onChange={onChange} />
        </Stack>
      </PageSection>
    </ServiceProviderLayout>
  );
}

const SetupObserver = observer(Setup);
export default withServiceProvider(SetupObserver);
